import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import e from "../../../Color.js";
import a from "../../../Graphic.js";
import { neverReached as r } from "../../../core/compilerUtils.js";
import i from "../../../core/Logger.js";
import { isSome as n, isNone as t } from "../../../core/maybe.js";
import { meterIn as s } from "../../support/lengthUtils.js";
import { isSizeVariable as o, isValidNumber as l } from "./sizeVariableUtils.js";
var c = i.getLogger("esri.renderers.visualVariables.support.visualVariableUtils"),
    u = new a(),
    f = Math.PI,
    p = /^\s*(return\s+)?\$view\.scale\s*(;)?\s*$/i;

function d(a, r, i) {
  var t = "visualVariables" in a && a.visualVariables ? a.visualVariables.filter(function (e) {
    return "color" === e.type;
  })[0] : a;
  if (!t) return;
  if ("esri.renderers.visualVariables.ColorVariable" !== t.declaredClass) return void c.warn("The visualVariable should be an instance of esri.renderers.visualVariables.ColorVariable");
  var s = "number" == typeof r,
      o = s ? null : r,
      l = o && o.attributes;
  var u = s ? r : null;
  var f = t.field,
      _t$cache = t.cache,
      p = _t$cache.ipData,
      d = _t$cache.hasExpression;
  var v = t.cache.compiledFunc;

  if (!f && !d) {
    var _e = t.stops;
    return _e && _e[0] && _e[0].color;
  }

  if ("number" != typeof u) if (d) {
    if (!n(i) || !n(i.arcade)) return void c.error("Use of arcade expressions requires an arcade context");

    var _e2 = {
      viewingMode: i.viewingMode,
      scale: i.scale,
      spatialReference: i.spatialReference
    },
        _a = i.arcade.arcadeUtils,
        _r = _a.getViewInfo(_e2),
        _s = _a.createExecContext(o, _r);

    if (!v) {
      var _e3 = _a.createSyntaxTree(t.valueExpression);

      v = _a.createFunction(_e3), t.cache.compiledFunc = v;
    }

    u = _a.executeFunction(v, _s);
  } else l && (u = l[f]);
  var b = t.normalizationField,
      h = l ? parseFloat(l[b]) : void 0;

  if (null != u && (!b || s || !isNaN(h) && 0 !== h)) {
    isNaN(h) || s || (u /= h);

    var _a2 = C(u, p);

    if (_a2) {
      var _r2 = _a2[0],
          _s2 = _a2[1],
          _o = _r2 === _s2 ? t.stops[_r2].color : e.blendColors(t.stops[_r2].color, t.stops[_s2].color, _a2[2], n(i) ? i.color : void 0);

      return new e(_o);
    }
  }
}

function v(e, a, r) {
  var i = "visualVariables" in e && e.visualVariables ? e.visualVariables.filter(function (e) {
    return "opacity" === e.type;
  })[0] : e;
  if (!i) return;
  if ("esri.renderers.visualVariables.OpacityVariable" !== i.declaredClass) return void c.warn("The visualVariable should be an instance of esri.renderers.visualVariables.OpacityVariable");
  var n = "number" == typeof a,
      s = n ? null : a,
      o = s && s.attributes;
  var l = n ? a : null;
  var u = i.field,
      _i$cache = i.cache,
      f = _i$cache.ipData,
      p = _i$cache.hasExpression;
  var d = i.cache.compiledFunc;

  if (!u && !p) {
    var _e4 = i.stops;
    return _e4 && _e4[0] && _e4[0].opacity;
  }

  if ("number" != typeof l) if (p) {
    if (t(r) || t(r.arcade)) return void c.error("Use of arcade expressions requires an arcade context");

    var _e5 = {
      viewingMode: r.viewingMode,
      scale: r.scale,
      spatialReference: r.spatialReference
    },
        _a3 = r.arcade.arcadeUtils,
        _n = _a3.getViewInfo(_e5),
        _o2 = _a3.createExecContext(s, _n);

    if (!d) {
      var _e6 = _a3.createSyntaxTree(i.valueExpression);

      d = _a3.createFunction(_e6), i.cache.compiledFunc = d;
    }

    l = _a3.executeFunction(d, _o2);
  } else o && (l = o[u]);
  var v = i.normalizationField,
      b = o ? parseFloat(o[v]) : void 0;

  if (null != l && (!v || n || !isNaN(b) && 0 !== b)) {
    isNaN(b) || n || (l /= b);

    var _e7 = C(l, f);

    if (_e7) {
      var _a4 = _e7[0],
          _r3 = _e7[1];
      if (_a4 === _r3) return i.stops[_a4].opacity;
      {
        var _n2 = i.stops[_a4].opacity;
        return _n2 + (i.stops[_r3].opacity - _n2) * _e7[2];
      }
    }
  }
}

function b(e, a, r) {
  var i = "visualVariables" in e && e.visualVariables ? e.visualVariables.filter(function (e) {
    return "rotation" === e.type;
  })[0] : e;
  if (!i) return;
  if ("esri.renderers.visualVariables.RotationVariable" !== i.declaredClass) return void c.warn("The visualVariable should be an instance of esri.renderers.visualVariables.RotationVariable");
  var n = i.axis || "heading",
      s = "heading" === n && "arithmetic" === i.rotationType ? 90 : 0,
      o = "heading" === n && "arithmetic" === i.rotationType ? -1 : 1,
      l = "number" == typeof a ? null : a,
      u = l && l.attributes,
      f = i.field,
      p = i.cache.hasExpression;
  var d = i.cache.compiledFunc,
      v = 0;
  if (!f && !p) return v;

  if (p) {
    if (t(r) || t(r.arcade)) return void c.error("Use of arcade expressions requires an arcade context");

    var _e8 = {
      viewingMode: r.viewingMode,
      scale: r.scale,
      spatialReference: r.spatialReference
    },
        _a5 = r.arcade.arcadeUtils,
        _n3 = _a5.getViewInfo(_e8),
        _s3 = _a5.createExecContext(l, _n3);

    if (!d) {
      var _e9 = _a5.createSyntaxTree(i.valueExpression);

      d = _a5.createFunction(_e9), i.cache.compiledFunc = d;
    }

    v = _a5.executeFunction(d, _s3);
  } else u && (v = u[f] || 0);

  return v = "number" != typeof v || isNaN(v) ? null : s + o * v, v;
}

function h(e, a, r) {
  var i = "number" == typeof a,
      s = i ? null : a,
      o = s && s.attributes;
  var u = i ? a : null;
  var f = e.cache.isScaleDriven;
  var p = e.cache.compiledFunc;

  if (f) {
    var _a6 = n(r) ? r.scale : void 0,
        _i = n(r) ? r.view : void 0;

    u = null == _a6 || "3d" === _i ? m(e) : _a6;
  } else if (!i) switch (e.inputValueType) {
    case "expression":
      {
        if (t(r) || t(r.arcade)) return void c.error("Use of arcade expressions requires an arcade context");

        var _a7 = {
          viewingMode: r.viewingMode,
          scale: r.scale,
          spatialReference: r.spatialReference
        },
            _i2 = r.arcade.arcadeUtils,
            _n4 = _i2.getViewInfo(_a7),
            _o3 = _i2.createExecContext(s, _n4);

        if (!p) {
          var _a8 = _i2.createSyntaxTree(e.valueExpression);

          p = _i2.createFunction(_a8), e.cache.compiledFunc = p;
        }

        u = _i2.executeFunction(p, _o3);
        break;
      }

    case "field":
      o && (u = o[e.field]);
      break;

    case "unknown":
      u = null;
  }

  if (!l(u)) return null;
  if (i || !e.normalizationField) return u;
  var d = o ? parseFloat(o[e.normalizationField]) : null;
  return l(d) && 0 !== d ? u / d : null;
}

function m(e) {
  var a = null,
      r = null;
  var i = e.stops;
  return i ? (a = i[0].value, r = i[i.length - 1].value) : (a = e.minDataValue || 0, r = e.maxDataValue || 0), (a + r) / 2;
}

function V(e, a, r) {
  var i = "visualVariables" in e && e.visualVariables ? e.visualVariables.filter(function (e) {
    return "size" === e.type;
  })[0] : e;
  if (!i) return;
  if ("esri.renderers.visualVariables.SizeVariable" !== i.declaredClass) return void c.warn("The visualVariable should be an instance of esri.renderers.visualVariables.SizeVariable");
  var n = M(h(i, a, r), i, a, r, i.cache.ipData);
  return null == n || isNaN(n) ? 0 : n;
}

function x(e, a, r) {
  return null == e ? null : o(e) ? V(e, a, r) : l(e) ? e : null;
}

function y(e, a, r) {
  return l(r) && e > r ? r : l(a) && e < a ? a : e;
}

function w(e, a, r, i) {
  return e + (x(a.minSize, r, i) || a.minDataValue);
}

function g(e, a, r) {
  var i = e.stops;
  var n = i && i.length && i[0].size;
  return null == n && (n = e.minSize), x(n, a, r);
}

function z(e, a, r, i) {
  var t = (e - a.minDataValue) / (a.maxDataValue - a.minDataValue),
      s = x(a.minSize, r, i),
      o = x(a.maxSize, r, i),
      l = n(i) ? i.shape : void 0;
  if (e <= a.minDataValue) return s;
  if (e >= a.maxDataValue) return o;

  if ("area" === a.scaleBy && l) {
    var _e10 = "circle" === l,
        _a9 = _e10 ? f * Math.pow(s / 2, 2) : s * s,
        _r4 = _a9 + t * ((_e10 ? f * Math.pow(o / 2, 2) : o * o) - _a9);

    return _e10 ? 2 * Math.sqrt(_r4 / f) : Math.sqrt(_r4);
  }

  return s + t * (o - s);
}

function F(e, a, r, i) {
  var t = n(i) ? i.shape : void 0,
      s = e / a.minDataValue,
      o = x(a.minSize, r, i),
      l = x(a.maxSize, r, i);
  var c = null;
  return c = "circle" === t ? 2 * Math.sqrt(s * Math.pow(o / 2, 2)) : "square" === t || "diamond" === t || "image" === t ? Math.sqrt(s * Math.pow(o, 2)) : s * o, y(c, o, l);
}

function S(e, a, r, i, n) {
  var _C = C(e, n),
      _C2 = _slicedToArray(_C, 3),
      t = _C2[0],
      s = _C2[1],
      o = _C2[2];

  if (t === s) return x(a.stops[t].size, r, i);
  {
    var _e11 = x(a.stops[t].size, r, i);

    return _e11 + (x(a.stops[s].size, r, i) - _e11) * o;
  }
}

function E(e, a, r, i) {
  var t = (n(i) && i.resolution ? i.resolution : 1) * s[a.valueUnit],
      o = x(a.minSize, r, i),
      l = x(a.maxSize, r, i),
      c = a.valueRepresentation;
  var u = null;
  return u = "area" === c ? 2 * Math.sqrt(e / f) / t : "radius" === c || "distance" === c ? 2 * e / t : e / t, y(u, o, l);
}

function D(e) {
  return e;
}

function M(e, a, r, i, n) {
  switch (a.transformationType) {
    case "additive":
      return w(e, a, r, i);

    case "constant":
      return g(a, r, i);

    case "clamped-linear":
      return z(e, a, r, i);

    case "proportional":
      return F(e, a, r, i);

    case "stops":
      return S(e, a, r, i, n);

    case "real-world-size":
      return E(e, a, r, i);

    case "identity":
      return D(e);

    case "unknown":
      return null;
  }
}

function U(e, a, r) {
  var i = e.cache.isScaleDriven;
  if (!(i && "3d" === r || a)) return null;
  var n = {
    scale: a,
    view: r
  };
  var t = x(e.minSize, u, n),
      s = x(e.maxSize, u, n);

  if (null != t || null != s) {
    if (t > s) {
      var _e12 = s;
      s = t, t = _e12;
    }

    return {
      minSize: t,
      maxSize: s
    };
  }
}

function k(e, a, r) {
  if (!e.visualVariables) return;
  var i = [],
      n = [],
      t = [],
      s = [],
      o = [];

  var _iterator = _createForOfIteratorHelper(e.visualVariables),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _l = _step.value;

      switch (_l.type) {
        case "color":
          n.push(_l);
          break;

        case "opacity":
          t.push(_l);
          break;

        case "rotation":
          o.push(_l);
          break;

        case "size":
          s.push(_l);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return n.forEach(function (e) {
    var n = d(e, a, r);
    i.push({
      variable: e,
      value: n
    });
  }), t.forEach(function (e) {
    var n = v(e, a, r);
    i.push({
      variable: e,
      value: n
    });
  }), o.forEach(function (e) {
    var n = b(e, a, r);
    i.push({
      variable: e,
      value: n
    });
  }), s.forEach(function (e) {
    var n = V(e, a, r);
    i.push({
      variable: e,
      value: n
    });
  }), i.filter(function (e) {
    return null != e.value;
  });
}

function C(e, a) {
  if (!a) return;
  var r = 0,
      i = a.length - 1;
  return a.some(function (a, n) {
    return e < a ? (i = n, !0) : (r = n, !1);
  }), [r, i, (e - a[r]) / (a[i] - a[r])];
}

function N(e, a, i) {
  var n = ["proportional", "proportional", "proportional"];

  var _iterator2 = _createForOfIteratorHelper(e),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _t = _step2.value;

      var _e13 = _t.useSymbolValue ? "symbol-value" : V(_t, a, i);

      switch (_t.axis) {
        case "width":
          n[0] = _e13;
          break;

        case "depth":
          n[1] = _e13;
          break;

        case "height":
          n[2] = _e13;
          break;

        case "width-and-depth":
          n[0] = _e13, n[1] = _e13;
          break;

        case "all":
        case void 0:
        case null:
          n[0] = _e13, n[1] = _e13, n[2] = _e13;
          break;

        default:
          r(_t.axis);
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return n;
}

export { N as getAllSizes, d as getColor, v as getOpacity, b as getRotationAngle, V as getSize, M as getSizeForValue, x as getSizeFromNumberOrVariable, U as getSizeRangeAtScale, k as getVisualVariableValues, p as viewScaleRE };